import script from "./Draft.vue?vue&type=script&setup=true&lang=js"
export * from "./Draft.vue?vue&type=script&setup=true&lang=js"

import "./Draft.vue?vue&type=style&index=0&id=58d1643f&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d1643f"]])

export default __exports__